"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaletteConfig = void 0;
var _react = require("react");
var _useSpectrumConditional = require("../hooks/useSpectrumConditional");
var _constants = require("./constants");
var _context = require("./context");
const usePaletteConfig = () => {
  const parentPalette = (0, _react.useContext)(_context.PaletteConfigContext);
  const defaultPalette = (0, _useSpectrumConditional.useSpectrumConditional)({
    light: _constants.defaultPalette,
    dark: _constants.darkDefaultPalette
  });
  return parentPalette !== null && parentPalette !== void 0 ? parentPalette : defaultPalette;
};
exports.usePaletteConfig = usePaletteConfig;